import { ColumnDef } from "@tanstack/react-table"

import type { MeterSizeRateType } from "@/types/meter"
import { DataTableColumnHeader } from "@/components/data-table"
import { MeterSizeRateOperation } from "../operations/meter-size-rates"

export const meterSizeRatesColumns: ColumnDef<MeterSizeRateType>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    cell: ({ row }) => {
      const value = row.original.id
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "rate_type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Rate Types" />
    ),
    cell: ({ row }) => {
      const value = row.original.rate_type
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "meter_size",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Meter Size" />
    ),
    cell: ({ row }) => {
      const value = row.original.meter_size
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "minimum_charge",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Minimum Charge" />
    ),
    cell: ({ row }) => {
      const value = row.original.minimum_charge
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "volume_range",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Volume Range" />
    ),
    cell: ({ row }) => {
      const value = row.original.volume_range
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "min_volume",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Min Volume" />
    ),
    cell: ({ row }) => {
      const value = row.original.min_volume
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "max_volume",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Max Volume" />
    ),
    cell: ({ row }) => {
      const value = row.original.max_volume
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => <div className="text-center">Actions</div>,
    cell: ({ row }: { row: { original: MeterSizeRateType } }) => (
      <div className="px-4 py-2 text-center md:py-0">
        <MeterSizeRateOperation data={row.original} />
      </div>
    ),
  },
]
